import { render } from "./Game.vue?vue&type=template&id=4a045265"
import script from "./Game.vue?vue&type=script&lang=js"
export * from "./Game.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\George Tomzaridis\\Desktop\\VueProjects\\cat-game\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__